export const allCertificatesAdded = 'There are no remaining certifications this user can have.';
export const dropdownPlaceholder = 'Select a certification...';
export const certifyHelpText = 'certify this user';
export const removeCertificateModalTitle = 'Remove certificate';
export const internalTechHelpText = 'Is internal technician';
export const internalTechLabel = 'Internal technicians will not see pay';
export const certificatesLabel = 'Certificates';
export const inviteToPineapple = 'Invite to Pineapple';
export const removeFromPineapple = 'Remove from Pineapple';
export const cubiCasaEmailLabel = 'CubiCasa e-mail';
export const cubiCasaEmailPlaceholder = 'CubiCasa email...';
export const add = 'add';
export const addCertificate = 'Add a certificate';
export const noCertificate = 'no certificate selected';
export const successfulAddition = 'Successfully added certification!';
export const successfulRemoval = 'Successfully removed certification!';
export const emptySet = 'this technician has no certificates yet';
export const errorAdding = (message: string) => `Error adding certificate: ${message}`;
export const errorRemoving = (message: string) => `Error removing certificate: ${message}`;
export const updateUserSuccess = (message) => `Successfully updated technician: ${message}!`;
export const errorUpdatingUser = (message) => `Error updating technician: ${message}`;
